import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer id="contact" className="site-footer">
      <div className="container footer-grid">
        <div>
          <h4>{t.footer.contact}</h4>
          <p>
            <a href="tel:+38640811830">040 811 830</a><br/>
            <a href="mailto:tajnistvo@op-bm.si">tajnistvo@op-bm.si</a>
          </p>
        </div>
        <div>
          <h4>{t.footer.location}</h4>
          <p>
            Slovenska cesta 24<br/>
            1234 Mengeš
          </p>
        </div>
        <div>
          <h4>{t.footer.accounts}</h4>
          <p>
            SI56 0230 1026 1287 120 (NLB)<br/>
            SI56 0230 1026 1287 508 (NLB F*)
          </p>
        </div>
      </div>
      <div className="credit">
        <span>© {new Date().getFullYear()} Odvetniška pisarna BM odvetniki</span>
        <Link to="/zasebnost" className="credit-link">{t.footer.privacy}</Link>
      </div>
    </footer>
  );
}
